/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import IconButton from '@material-ui/core/IconButton';
import Swal from 'sweetalert2';
import BuscaForm from '../../gww-lib/busca-no-form/index';
import Grid from '@material-ui/core/Grid';
import api from '../../../services/api';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import CampoTextoAjuda from '../../gww-lib/campo-texto-ajuda';

const useStyles = makeStyles(theme => ({
    formControl: {
    },
    ocultaCampo: {
        display: "none",
    },
    botaoRodape: {
        padding: theme.spacing(1),
    },
}))

export default function FormGrupoImpostoItem(props) {

    const { adicionarImpostos, removerImposto, grid, imposto, indexImposto } = props;

    const classes = useStyles();

    const [codigoItem, setCodigoItem] = useState(imposto ? imposto.codigoItem : 0);

    const [codigoImposto, setCodigoImposto] = useState(imposto ? imposto.codigoImposto : '');
    const [descricaoImposto, setDescricaoImposto] = useState(imposto ? imposto.descricaoImposto : '');
    const [codigoImpostoErro, setCodigoImpostoErro] = useState(false);
    const [codigoImpostoErroTexto, setCodigoImpostoErroTexto] = useState();

    const [modalidadeBaseCalculo, setModalidadeBaseCalculo] = useState(imposto ? imposto.modalidadeBaseCalculo : 0);
    const [modalidadeBaseCalculoErro] = useState(false);
    const [modalidadeBaseCalculoErroTexto] = useState();

    const [base, setBase] = useState(imposto ? imposto.base : 100);
    const [baseErro] = useState(false);
    const [baseErroTexto] = useState();

    const [aliquota, setAliquota] = useState(imposto ? imposto.aliquota : '');
    const [aliquotaErro, setAliquotaErro] = useState(false);
    const [aliquotaErroTexto, setAliquotaErroTexto] = useState();

    const [acrescimo, setAcrescimo] = useState(imposto ? imposto.acrescimo : 0);
    const [acrescimoErro] = useState(false);
    const [acrescimoErroTexto] = useState();

    const [reducao, setReducao] = useState(imposto ? imposto.reducao : 0);
    const [reducaoErro] = useState(false);
    const [reducaoErroTexto] = useState();

    const [operacaoPropria, setOperacaoPropria] = useState(imposto ? imposto.operacaoPropria : 0);
    const [operacaoPropriaErro] = useState(false);
    const [operacaoPropriaErroTexto] = useState();

    const [diferimento, setDiferimento] = useState(imposto ? imposto.diferimento : 0);
    const [diferimentoErro] = useState(false);
    const [diferimentoErroTexto] = useState();

    const [valorPauta, setValorPauta] = useState(imposto ? imposto.valorPauta : 0);
    const [valorPautaErro] = useState(false);
    const [valorPautaErroTexto] = useState();

    const [open, setOpen] = React.useState(false);


    useEffect(() => {
        if (imposto) {
            return
        }
        if (open) {
            setCodigoItem(0);
            setCodigoImposto('');
            setModalidadeBaseCalculo(0);
            setBase(100);
            setAliquota('');
            setAcrescimo(0);
            setReducao(0);
            setOperacaoPropria(0);
            setDiferimento(0);
            setValorPauta(0);
        }
    }, [open])


    function salvar() {
        if (validaCampos()) {
            adicionarImpostos(
                {
                    codigoItem,
                    codigoImposto,
                    descricaoImposto,
                    modalidadeBaseCalculo,
                    base,
                    aliquota,
                    acrescimo,
                    reducao,
                    operacaoPropria,
                    diferimento,
                    valorPauta
                }, indexImposto);

            const Toast = Swal.mixin({
                toast: true,
                position: 'top-right',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                onOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            })

            Toast.fire({
                type: 'success',
                title: 'Imposto Salvo'
            });
            setOpen(false);
        }


    }

    function cancelar() {
        setOpen(false);
    }

    async function deletar() {
        if (codigoItem) {

            let dadosEnvio = {
                DBSERVERNAME: localStorage.getItem("DBSERVERNAME"),
                DBUSERNAME: localStorage.getItem("DBUSERNAME"),
                DBESQUEMA: localStorage.getItem("DBESQUEMA"),
                DBPID: localStorage.getItem("DBPID"),
                MANDNUMBER: localStorage.getItem("MANDNUMBER"),
                PROCNAME: "WEBSITE_TIMPOSTO_GRUPOI_DELETE",
                EMPNUMBER: localStorage.getItem("EMPNUMBER"),
                PCCDTAXSEQ: codigoItem
            };

            const resposta = await api.post('/execute', dadosEnvio);
            if (resposta.data.CODIGO_ERRO == 0) {
                setOpen(false);
                removerImposto(indexImposto);
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-right',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    onOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    type: 'success',
                    title: 'Item Removido'
                })
            }
        } else {
            setOpen(false);
            removerImposto(indexImposto);
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-right',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                onOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            })

            Toast.fire({
                type: 'success',
                title: 'Item Removido'
            })
        }

    }

    function apresentarDeletar() {
        if (imposto) {
            return <Grid item xs={6} className={classes.botaoRodape}>
                <Button
                    variant="contained"
                    color="secondary"
                    type="button"
                    onClick={deletar}
                    fullWidth
                >
                    Deletar
</Button>
            </Grid>
        }
    }

    const handleOpen = (e) => {
        e.preventDefault();
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    function validaCampos() {
        let camposErrados = [];


        if (codigoImposto === '') {
            setCodigoImpostoErro(true);
            setCodigoImpostoErroTexto(`Campo obrigatorio, Por favor preencha`)
            camposErrados.push("Imposto")
        } else {
            if (descricaoImposto === '') {
                setCodigoImpostoErro(true);
                setCodigoImpostoErroTexto('Informe um Imposto Valido, use a pesquisa.')
                camposErrados.push("Imposto")
            } else {
                setCodigoImpostoErro(false);
            }
        }

        if (aliquota === '') {
            setAliquotaErro(true);
            setAliquotaErroTexto('Campo Obrigatorio. Por favor preencha a descrição.');
            camposErrados.push("Aliquota");
        } else {
            setAliquotaErro(false);
        }

        if (camposErrados.length === 0) {
            return true;
        } else {
            return false;
        }

    };

    return (
        <div>
            {grid ? <IconButton aria-label="alterar"
                onClick={handleOpen}
            >
                <EditRoundedIcon />
            </IconButton> : <Button
                type="button"
                color="primary"
                variant="contained"
                onClick={handleOpen}>
                Adicionar Item
      </Button>}

            <Dialog
                open={open}
                onClose={handleClose}
                scroll='paper'
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                fullScreen
            >
                <DialogTitle id="scroll-dialog-title">
                    <Grid container>
                        <Grid item xs={6} className={classes.botaoRodape}>
                            Impostos
                        </Grid>
                        {apresentarDeletar()}

                    </Grid>
                </DialogTitle>
                <DialogContent dividers='true'>
                    <DialogContentText
                        id="scroll-dialog-description"

                        tabIndex={-1}
                    >

                        <form>
                            <BuscaForm
                                ocultaCodigo
                                codigo={codigoImposto}
                                tabela="IMPOSTO"
                                label="Imposto"
                                consultaInstantanea
                                setCodigoPai={(codigoImposto) => setCodigoImposto(codigoImposto)}
                                setDescricao={setDescricaoImposto}
                                descricao={descricaoImposto}
                                procedureConsulta="WEBSITE_LISTAGEM_TIMPOSTO"
                                erroTexto={codigoImpostoErroTexto}
                                erro={codigoImpostoErro}
                                ajuda={{
                                    obrigatorio: true,
                                    tituloAjuda: 'Imposto',
                                    textoAjuda: 'Informar o imposto que será destacado, para selecionar utilize o botão de pesquisa.',
                                    saibaMais: {
                                        categoria: 'grupo-imposto-item',
                                        campo: 'imposto'
                                    }
                                }}
                            />

                            {codigoImposto == 1 ? <>
                                <FormControl variant="outlined"
                                    className={codigoImposto == 1 || codigoImposto == 11 ? classes.formControl : classes.ocultaCampo}
                                    fullWidth
                                >

                                    <InputLabel>
                                        Mod. Bas. Calc.
                                </InputLabel>


                                    <Select
                                        error={modalidadeBaseCalculoErro}
                                        helperText={modalidadeBaseCalculoErroTexto}
                                        value={modalidadeBaseCalculo}
                                        onChange={e => setModalidadeBaseCalculo(e.target.value)}

                                    >
                                        <MenuItem value={0}>0 - Margem Valor Agregado (%)</MenuItem>
                                        <MenuItem value={1}>1 - Pauta (Valor)</MenuItem>
                                        <MenuItem value={2}>2 - Preço Tabelado Máx. (valor)</MenuItem>
                                        <MenuItem value={3}>3 - Valor da operação</MenuItem>
                                    </Select>

                                </FormControl></> : <>
                                <FormControl variant="outlined"
                                    className={codigoImposto == 1 || codigoImposto == 11 ? classes.formControl : classes.ocultaCampo}
                                    fullWidth
                                >

                                    <InputLabel>
                                        Mod. Bas. Calc.
                                </InputLabel>


                                    <Select
                                        error={modalidadeBaseCalculoErro}
                                        helperText={modalidadeBaseCalculoErroTexto}
                                        value={modalidadeBaseCalculo}
                                        onChange={e => setModalidadeBaseCalculo(e.target.value)}

                                    >
                                        <MenuItem value={0}>0 -Preço tabelado ou máximo sugerido</MenuItem>
                                        <MenuItem value={1}>1 - Lista Negativa (valor)</MenuItem>
                                        <MenuItem value={2}>2 - Lista Positiva (valor)</MenuItem>
                                        <MenuItem value={3}>3 - Lista Neutra (valor)</MenuItem>
                                        <MenuItem value={4}>4 - Margem Valor Agregado (%)</MenuItem>
                                        <MenuItem value={5}>5 - Pauta (valor)</MenuItem>


                                    </Select>

                                </FormControl></>}

                            <CampoTextoAjuda
                                className={classes.textField}
                                label="% Base"
                                type="number"
                                error={baseErro}
                                helperText={baseErro ? baseErroTexto : ''}
                                value={base}
                                onChange={e => setBase(e.target.value)}
                                tituloAjuda="Base de Calculo"
                                textoAjuda="Informar o percentual do valor do produto que será utilizado como base para calcular o imposto."
                                saibaMais={{
                                    categoria: 'grupo-imposto-item',
                                    campo: 'base'
                                }}
                            />

                            <CampoTextoAjuda
                                className={classes.textField}
                                label="% Alíquota"
                                type="number"
                                error={aliquotaErro}
                                helperText={aliquotaErro ? aliquotaErroTexto : ''}
                                value={aliquota}
                                onChange={e => setAliquota(e.target.value)}
                                tituloAjuda="Percentual Alíquota"
                                textoAjuda="Informe o percentual de alíquota que será utilizado para calcular o imposto."
                                saibaMais={{
                                    categoria: 'grupo-imposto-item',
                                    campo: 'aliquota'
                                }}
                            />

                            <CampoTextoAjuda
                                className={codigoImposto == 1 || codigoImposto == 11 ? classes.textField : classes.ocultaCampo}
                                label="% Acréscimo"
                                type="number"
                                obrigatorio={false}
                                error={acrescimoErro}
                                helperText={acrescimoErro ? acrescimoErroTexto : ''}
                                value={acrescimo}
                                onChange={e => setAcrescimo(e.target.value)}
                                tituloAjuda="Acréscimo da Base"
                                textoAjuda="Informar o percentual que será acrescentado na base de cálculo."
                                saibaMais={{
                                    categoria: 'grupo-imposto-item',
                                    campo: 'acrescimo'
                                }}
                            />

                            <CampoTextoAjuda
                                className={codigoImposto == 1 || codigoImposto == 11 ? classes.textField : classes.ocultaCampo}
                                label="% Redução"
                                type="number"
                                obrigatorio={false}
                                error={reducaoErro}
                                helperText={reducaoErro ? reducaoErroTexto : ''}
                                value={reducao}
                                onChange={e => setReducao(e.target.value)}
                                tituloAjuda="Redução da Base"
                                textoAjuda="Informar o percentual que será reduzido na base de cálculo."
                                saibaMais={{
                                    categoria: 'grupo-imposto-item',
                                    campo: 'reducao'
                                }}
                            />

                            {/* <TextField
                                className={ codigoImposto == 11 ? classes.textField : classes.ocultaCampo}
                                label="Operação Propria"
                                type="number"
                                error={operacaoPropriaErro}
                                helperText={operacaoPropriaErroTexto}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                                value={operacaoPropria}
                                onChange={e => setOperacaoPropria(e.target.value)}
                            /> */}

                            <CampoTextoAjuda
                                className={codigoImposto == 1 || codigoImposto == 11 ? classes.textField : classes.ocultaCampo}
                                label="Operação Propria"
                                type="number"
                                obrigatorio={false}
                                error={operacaoPropriaErro}
                                helperText={operacaoPropriaErro ? operacaoPropriaErroTexto : ''}
                                value={operacaoPropria}
                                onChange={e => setOperacaoPropria(e.target.value)}
                                tituloAjuda="Operação Propria"
                                textoAjuda="Informar o percentual que será reduzido na base de cálculo."
                                saibaMais={{
                                    categoria: 'grupo-imposto-item',
                                    campo: 'reducao'
                                }}
                            />

                            <TextField
                                className={codigoImposto == 1 ? classes.textField : classes.ocultaCampo}
                                label="% Diferimento"
                                type="number"
                                error={diferimentoErro}
                                helperText={diferimentoErroTexto}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                                value={diferimento}
                                onChange={e => setDiferimento(e.target.value)}
                            />

                            <TextField
                                className={codigoImposto == 1 || codigoImposto == 11 ? classes.textField : classes.ocultaCampo}
                                label="Valor Pauta"
                                type="number"
                                error={valorPautaErro}
                                helperText={valorPautaErroTexto}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                                value={valorPauta}
                                onChange={e => setValorPauta(e.target.value)}
                            />



                        </form>

                    </DialogContentText>


                </DialogContent>
                <DialogActions>
                    <Grid container>
                        <Grid item xs={6} className={classes.botaoRodape}>
                            <Button
                                variant="contained"
                                color="secondary"
                                type="button"
                                onClick={cancelar}
                                fullWidth
                            >
                                Cancelar
                                </Button>
                        </Grid>
                        <Grid item xs={6} className={classes.botaoRodape}>
                            <Button
                                variant="contained"
                                color="primary"
                                type="submit"
                                onClick={salvar}
                                fullWidth
                            >
                                Salvar
                                </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>


        </div>
    )
}